import axios, { AxiosError, AxiosResponse } from 'axios';
import { Envelope } from '../interfaces/envelope';
import { userLogout } from './deinitialization';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept-Language'] = 'en';

axios.interceptors.request.use(
	(config) => {
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

axios.interceptors.response.use(
	(response: AxiosResponse) => {
		return response;
	},
	(error: AxiosError<Envelope<null>>) => {
		if (error.response && [401, 403].includes(error.response.status)) {
			userLogout(true);
		}
		return Promise.reject(error);
	}
);
